import script from "./WolfVisionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./WolfVisionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./WolfVisionComponent.vue?vue&type=style&index=0&id=e4c881e0&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c881e0"]])

export default __exports__